<template>
  <a-modal
    title="付款申请"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', this.otherData) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24">
            <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择项目' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-cascader
                v-decorator="[
                  'contract_type',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                :options="this.tradePaymentRelatedContract"
                placeholder="请选择"
                @change="contractTypeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedProjectId !== undefined && contractType === 100">
            <a-form-item label="购销合同" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                @change="handleSellContractChange"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedProjectId !== undefined && contractType === 200">
            <a-form-item label="普通合同" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in contractList">{{ val.contract_name }}（{{ val.business_no }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProjectId !== undefined">
            <a-form-item label="合同主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>
                {{ selectedProjectHostCorporation }}
              </span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="paymentCompanyFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'payment_company_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.corporationSearch"
              >
                <a-spin v-if="paymentCompanyFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in paymentCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款事由" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'payment_reason',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in paymentApplicationReason">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['payment_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
              <a-select
                style="width: 50%"
                allow-clear
                v-decorator="[
                  'payment_amount_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款事由说明" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['payment_reason_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              收款账户信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收款公司" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :filter-option="false"
                :not-found-content="payeeCorporationFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'payee_company_id',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                placeholder="请输入公司名称"
                :default-active-first-option="false"
                @search="this.payeeCorporationSearch"
              >
                <a-spin v-if="payeeCorporationFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in payeeCompanyList" :key="d.id" :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行账号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_account', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行地址" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bank_address', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="SWIFT CODE" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['swift_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="大额行号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['cnaps_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="contract_attachment.length > 0">
            <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-table
                bordered
                :data-source="contract_attachment"
                :columns="attachmentColumns"
                :pagination="false"
                key="key">
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :visible="visibleFrom"
        :loading="false"
        v-if="visibleFrom"
        :model="undefined" />
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { bank_list } from '@/api/trade_bank'
import { project_list } from '@/api/trade_project'
import { sell_contract_list } from '@/api/trade_sell_contract'
import {
  booking_contract_list,
  charter_party_contract_list,
  freight_forwarding_contract_list,
  inspection_contract_list,
  insurance_contract_list,
  loading_supervision_contract_list,
  storage_contract_list, supervision_contract_list
} from '@/api/trade_contract'
import { guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { contract_list } from '@/api/contract'
import { corporation_list } from '@/api/trade_corporation'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { sell_contract_attachment_list } from '@/api/trade_sell_contract_attachment'
import { client_list } from '@/api/trade_client'

// 表单字段
const fields = ['business_no']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.bankSearch = debounce(this.handleBankSearch, 800)
    this.advisingBankSearch = debounce(this.handleAdvisingBankSearch, 800)
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.corporationSearch = debounce(this.handleCorporationSearch, 800)
    this.payeeCorporationSearch = debounce(this.handlePayeeCorporationSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      bankList: [],
      advisingBankList: [],
      projectList: [],
      sellContractList: [],
      contractList: [],
      paymentCompanyList: [],
      payeeCompanyList: [],
      projectFetching: false,
      bankFetching: false,
      paymentCompanyFetching: false,
      payeeCorporationFetching: false,
      advisingBankFetching: false,
      contractFetching: false,
      selectedSellContract: undefined,
      selectedProjectId: undefined,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      paymentApplicationReasonList: this.$Dictionaries.trade_payment_application_reasons,
      paymentApplicationReasonList2: this.$Dictionaries.trade_payment_application_reasons2,
      letterCreditTypeList: this.$Dictionaries.letter_credit_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      contractType: 0,
      selectedLetterCreditType: 0,
      accordingContract: true,
      visibleFrom: false,
      contract_attachment: [],
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    selectedProjectHostCorporation () {
      if (this.projectList !== undefined && this.projectList.length > 0 && this.selectedProjectId !== undefined) {
        return this.projectList.filter(item => item.id === this.selectedProjectId)[0].host_corporation
      }
      return ''
    },
    paymentApplicationReason () {
     if (this.contractType === 100) {
       return this.paymentApplicationReasonList
     } else if (this.contractType === 200) {
       return this.paymentApplicationReasonList2
     }
     return []
    }
  },
  methods: {
    moment,
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        this.projectList = res.data.entries || []
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleCorporationSearch (value) {
      this.paymentCompanyFetching = true
      corporation_list({ name: value }).then((res) => {
        this.paymentCompanyList = res.data.entries || []
      }).finally(() => {
        this.paymentCompanyFetching = false
      })
    },
    handlePayeeCorporationSearch (value) {
      this.payeeCorporationFetching = true
      client_list({ name: value }).then((res) => {
        this.payeeCompanyList = res.data.entries || []
      }).finally(() => {
        this.payeeCorporationFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.sellContractList = []
        this.form.setFieldsValue({ sell_contract_id: undefined })
        this.form.setFieldsValue({ contract_id: undefined })
        // this.handleSellContractSearch()
      }
    },
    contractTypeChange (values) {
      if (values !== undefined && values.length === 2) {
        this.contractType = values[0]
        this.contractList = []
        this.sellContractList = []
        this.form.setFieldsValue({ sell_contract_id: undefined })
        this.form.setFieldsValue({ contract_id: undefined })
        if (values[0] === 100) {
          this.handleSellContractSearch(values[1])
        } else {
          this.handleContractSearch(values[1])
        }
      }
    },
    handleSellContractSearch (value) {
      this.contractFetching = true
      this.sellContractList = []
      sell_contract_list({ project_id: this.$route.params.project_id === undefined ? this.selectedProjectId : this.$route.params.project_id, is_expired: false, page: 1, page_size: 999, type: (value === 101 ? 1 : 2) }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.contractFetching = false
      })
    },
    handleContractSearch (type) {
      this.contractFetching = true
      this.contractList = []
      this.contractApiByType(type, { project_id: this.selectedProjectId, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.contractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.business_no === current.business_no)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.contractFetching = false
      })
    },
    contractApiByType (type, data) {
      switch (type) {
        case 201:
          return storage_contract_list(data)
        case 206:
          return freight_forwarding_contract_list(data)
        case 203:
          return charter_party_contract_list(data)
        case 204:
          return booking_contract_list(data)
        case 205:
          return inspection_contract_list(data)
        case 207:
          return loading_supervision_contract_list(data)
        case 202:
          return insurance_contract_list(data)
        case 208:
          return supervision_contract_list(data)
        case 209:
          return guarantee_contract_list(data)
        default:
          return contract_list(data)
      }
    },
    handleSellContractChange (value) {
      console.log(value)
      this.selectedSellContract = this.sellContractList.filter(item => item.id === value)[0]
      if (this.selectedSellContract) {
        sell_contract_attachment_list({ sell_contract_id: value }).then(res => {
          if (res.code === 1000) {
            this.contract_attachment = res.data.entries || []
          }
        })
      }
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    handleBankSearch (value) {
      this.bankFetching = true
      bank_list({ name: value }).then((res) => {
        this.bankList = res.data.entries || []
      }).finally(() => {
        this.bankFetching = false
      })
    },
    handleAdvisingBankSearch (value) {
      this.advisingBankFetching = true
      bank_list({ name: value }).then((res) => {
        this.advisingBankList = res.data.entries || []
      }).finally(() => {
        this.advisingBankFetching = false
      })
    },
    handleBankChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleBankSearch(value)
      }
    },
    handleAccordingContractChange (value) {
      this.accordingContract = value
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onDateChange (date, dateString) {
      // console.log(date, dateString)
      this.date.start_date = dateString
      // this.date.end_date = dateString[1]
    }
  }
}
</script>
